import { getDefaultConfig } from "@rainbow-me/rainbowkit";
import { bsc } from "wagmi/chains";

const walletConnectProjectId = "8d2b882eb88f45825aaf821c03462a32";

export const supportedChains = [bsc];

export const wagmiConfig = getDefaultConfig({
  appName: "Chronos Arte Node",
  projectId: walletConnectProjectId,
  chains: supportedChains,
  ssr: false,
});
